import React, { useCallback } from 'react';
import { Link, LinkWithIcon } from 'components';
import styled from 'styled-components';
import { media } from 'theme';
import useSearch from 'hooks/useSearch';
import { useGlobalContext } from 'constants/context';
import { resetCatalogCache } from 'pages/Home/homeStateCache';

const LogoText = styled.span`
  font-size: 24px;
  white-space:nowrap
`;
const Container = styled.footer`
    padding: 20px 16px 20px;
  ${media.greaterThan('md')`      
  padding: 90px 80px 100px;    
  `}
  ${'' /* ${media.greaterThan('1624px')`
  padding: 90px 0px 100px;
  `} */}
  min-height: 232px;
  display: flex;  
  align-items: center;
`;

const Column = styled.div`
  display: flex;
  width:100%;
  flex-direction:column;
`;
const Row = styled.div`
  display: flex;
`;
const Line = styled.div`
  color: #272727;
`;
const Footer = () => {
  const { setContextState } = useGlobalContext();
  const { setSearch, ifNotHomeGoToHome } = useSearch();
  const onClickCatalog = useCallback(() => {
    setSearch('');
    ifNotHomeGoToHome();
    setContextState((state) => ({ ...state, filters: [] }));
    resetCatalogCache();
    window.scrollTo(0, 0);
  }, [ifNotHomeGoToHome, setContextState, setSearch]);
  return (
    <Container>
      <Column>
        <Row className="catalog-website-line">
          <Link className="logo-link" onClick={onClickCatalog} to="/">
            <LogoText className="logo-text">BaseCamp Library Catalog</LogoText>
          </Link>
          <LinkWithIcon iconAtStart iconAtEnd marginTopIcon={-2} className="logo-link" to="/" local={false}>
            <span>BaseCamp Website</span>
          </LinkWithIcon>
        </Row>
        <Column className="about-site">
          <Line>
            <Link to="/" local={false}>BaseCamp Library</Link> | E-mail: <a href="mailto:basecamplibrary@gmail.com">basecamplibrary@gmail.com</a>
          </Line>
        </Column>
      </Column>
    </Container>
  );
};

export default Footer;
